import "./hotel-card.scss";

const HotelCard = ({ imgSrc, name, place, offer, amount, detail, onClick }) => {
  const discType = (type) => {
    switch (type) {
      case "percentage":
        return "%";
      case "flat":
        return "rs FLAT";
      default:
        return null;
    }
  };

  return (
    <div className="hotel-card" onClick={onClick}>
      <img src={imgSrc} className="hotel-image" alt="" />
      <div className="hotel-text-section">
        <div className="name">{name}</div>
        {place && <div className="place">{place}</div>}
        {detail && <div className="place">{detail}</div>}
        {offer && offer.couponId > 0? (
          <div className="offer">
            {offer?.discountValue}
            {discType(offer?.discountType)} {"OFF"}
          </div>
        ):null}
        {amount && (
          <div className="amount">
            <span>&#8377;</span>
            {amount}
          </div>
        )}
      </div>
    </div>
  );
};

export default HotelCard;
